<form [formGroup]="dvaForm">
  <div fxLayout="column">
    <mat-form-field fxFlex>
      <mat-label>Membership Number</mat-label>
      <input matInput formControlName="number" [required]="true" />
    </mat-form-field>
  </div>
</form>
